var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:play-circle-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.416 35.7458V56.2541C36.416 57.7236 37.0868 58.8416 38.4285 59.6083C39.7702 60.375 41.0799 60.3111 42.3577 59.4166L58.266 49.2583C59.4799 48.4916 60.0868 47.4055 60.0868 46C60.0868 44.5944 59.4799 43.5083 58.266 42.7416L42.3577 32.5833C41.0799 31.6888 39.7702 31.625 38.4285 32.3916C37.0868 33.1583 36.416 34.2763 36.416 35.7458ZM45.9993 84.3333C40.6966 84.3333 35.7132 83.3264 31.0494 81.3126C26.3855 79.3014 22.3285 76.5708 18.8785 73.1208C15.4285 69.6708 12.6979 65.6138 10.6867 60.95C8.6729 56.2861 7.66602 51.3027 7.66602 46C7.66602 40.6972 8.6729 35.7139 10.6867 31.05C12.6979 26.3861 15.4285 22.3291 18.8785 18.8791C22.3285 15.4291 26.3855 12.6972 31.0494 10.6835C35.7132 8.67224 40.6966 7.66663 45.9993 7.66663C51.3021 7.66663 56.2855 8.67224 60.9493 10.6835C65.6132 12.6972 69.6702 15.4291 73.1202 18.8791C76.5702 22.3291 79.3008 26.3861 81.312 31.05C83.3258 35.7139 84.3327 40.6972 84.3327 46C84.3327 51.3027 83.3258 56.2861 81.312 60.95C79.3008 65.6138 76.5702 69.6708 73.1202 73.1208C69.6702 76.5708 65.6132 79.3014 60.9493 81.3126C56.2855 83.3264 51.3021 84.3333 45.9993 84.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhite);
export default __webpack_public_path__ + "static/media/playWhite.6e0c2b02330c0daa0c243b5590b9e934.svg";
export { ForwardRef as ReactComponent };